import React, { useEffect, useState } from "react";
import { Carousel } from "react-responsive-carousel";
import { useNavigate } from "react-router-dom";
import { useMutation, useQuery } from "react-query";
import { bannersFn } from "../../Services/Home/Banners";
import { categoriesFn } from "../../Services/Home/Categories";
import { recentlyAddedFn } from "../../Services/Home/RecentlyAdded";
import { recommandedProductsFn } from "../../Services/Home/RecommendedProducts";
import { topRatedProductsFn } from "../../Services/Home/TopRatedProducts";
import Checkout from "../../Components/Checkout";
import WishlistButton from "../../Shared/WishlistButton";
import { mostViewedProductsFn } from "../../Services/Products/ProductDetail/MostViewedProducts";
import { Backdrop, CircularProgress } from "@mui/material";
import SearchModal from "../../Shared/Search";
import icon from "../../neon-bhaarat-store-logo-white-svg-01-1.svg"
import { LoadScript } from "@react-google-maps/api";
import LocationModal from "../../Shared/Location";
import { getHomePageData } from "../../Services/Home/HomePageCategoryData";

const Home = () => {
  const [banners, setBanners] = useState([]);
  const navigate = useNavigate();

  const { data: HomePageData } = useQuery(["home-page-data"], () => getHomePageData())
  const { mutate: bannersList, isLoading } = useMutation(bannersFn, {
    onSuccess: (res) => {
      setBanners(res.data.data);
    },
  });
  useEffect(
    () => {
      bannersList();
    },
    // eslint-disable-next-line
    []
  );

  const { data: categories, isLoading: isLoadingCategories } = useQuery(
    ["categories"],
    () => categoriesFn(),
    {
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
    }
  );

  const carousels = banners?.filter(
    (banner_section) => banner_section.banner_section === "category_banner"
  );

  const { data: recentlyAdded, isLoading: isLoadingRecently } = useQuery(
    ["recentlyAdded"],
    () => recentlyAddedFn(),
    {
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
    }
  );
  const { data: recommandedProducts, isLoading: isLoadingRecommended } =
    useQuery(["recommandedProducts"], () => recommandedProductsFn(), {
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
    });
  const { data: topRatedProducts } = useQuery(
    ["topRatedProducts"],
    () => topRatedProductsFn(),
    {
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
    }
  );
  const { data: mostViewedProducts } = useQuery(
    ["mostViewedProducts"],
    () => mostViewedProductsFn(),
    {
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
    }
  );

  return isLoading &&
    isLoadingCategories &&
    isLoadingRecently &&
    isLoadingRecommended ? (
    <Backdrop
      sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
      open={true}
    >
      <CircularProgress size={40} />
    </Backdrop>
  ) : (
    <>
      <div className="fixed flex items-center justify-between top-0 h-16 z-50 bg-white dark:bg-zinc-900 py-2 px-3 w-full shadow">
        <img src={icon} alt="" className="h-16 pb-1" />
        <div className="flex gap-2  items-center">
          <SearchModal />

          <LoadScript
            googleMapsApiKey="AIzaSyAO3TRgzZx5X3i6tTcuNMjCvvCxhWe4M3g"
            libraries={['places']}
          >
            <LocationModal />
          </LoadScript>
          <WishlistButton />
          <Checkout />
        </div>
      </div>
      <div className="!bg-zinc-200 dark:bg-zinc-700 py-[65px]">
        <div className="flex justify-center ">
          <Carousel
            autoPlay
            showStatus={false}
            showThumbs={false}
            showIndicators={false}
            showArrows={false}
          >
            {carousels?.slice(0, 10).map((banner, index) => {
              return (
                <div
                  key={index + 1}
                  onClick={() =>
                    navigate("/category", {
                      state: {
                        from: "category",
                        categoryId: banner.category_id,
                        categoryName: banner.category_name,
                      },
                    })
                  }
                >
                  <img src={banner.image} alt="" />
                </div>
              );
            })}
          </Carousel>
        </div>
        <div className="flex bg-white dark:bg-zinc-900 p-2">
          <div className="flex items-center gap-3 overflow-x-auto hide-scroll">
            <img
              src="https://pub-8de1a28f49c04a568b19557f02b6129b.r2.dev/Assets/PhoneVersion/All products.png"
              alt=""
              className="shadow w-16 border border-zinc-200 dark:border-zinc-700 rounded-full"
              onClick={() =>
                navigate("/all-products", {
                  state: {
                    from: "allProduct",
                    title: "All Products",
                  },
                })
              }
            />
            {categories?.data?.data?.main_category_list?.map((item, index) => {
              return (
                <>
                  <img
                    src={item.image}
                    alt=""
                    key={index + 1}
                    className="h-16 w-16 rounded-full"
                    onClick={() =>
                      navigate("/category", {
                        state: {
                          from: "category",
                          categoryId: item.id,
                          categoryName: item.category,
                        },
                      })
                    }
                  />
                </>
              );
            })}
          </div>
        </div>
        <span className="flex flex-col">
          {banners?.slice(0, 7)?.map((banner) => {
            return (
              <img
                src={banner.image}
                alt=""
                className="rounded w-full"
                onClick={() =>
                  navigate("/category", {
                    state: {
                      from: "category",
                      categoryId: banner.category_id,
                      categoryName: banner.category_name,
                    },
                  })
                }
              />
            );
          })}
        </span>

        <div className="">
          <p className="absolute pt-10 font-serif font-bold text-2xl text-center w-full">
            New On Bhaarat Store
          </p>
          <img
            src="https://pub-8de1a28f49c04a568b19557f02b6129b.r2.dev/Assets/PhoneVersion/images/s.jpg"
            alt=""
            className="w-full"
          />
        </div>

        <div className="bg-[#BB9BFE] pb-3">
          <div className="grid gap-3 grid-cols-3 px-3">
            {recentlyAdded?.data?.data?.product_list
              ?.slice(0, 9)
              ?.map((product, index) => {
                return (
                  <div
                    key={index + 1}
                    className="bg-white dark:bg-zinc-900 p-2 rounded"
                    onClick={() =>
                      navigate(`/product/${product.id}/${product.slug}`)
                    }
                  >
                    <img
                      src={product.variant_image || product.image}
                      alt=""
                      className="rounded"
                    />
                    <p className="text-sm w-24 overflow-hidden whitespace-nowrap text-ellipsis font-semibold">
                      {product.title}
                    </p>
                    <p className="text-sm text-green-500">
                      From ₹{product.actual_price}
                    </p>
                  </div>
                );
              })}
          </div>
        </div>
        <span className="flex flex-col">
          {banners?.slice(7, 11)?.map((banner) => {
            return (
              <img
                src={banner.image}
                alt=""
                className="rounded w-full"
                onClick={() =>
                  navigate("/category", {
                    state: {
                      from: "category",
                      categoryId: banner.category_id,
                      categoryName: banner.category_name,
                    },
                  })
                }
              />
            );
          })}
        </span>
        <div className="">
          <p className="absolute pt-10 font-serif font-bold text-2xl text-center w-full">
            Recommended Products
          </p>
          <img
            src="https://pub-8de1a28f49c04a568b19557f02b6129b.r2.dev/Assets/PhoneVersion/images/k.jpg"
            alt=""
            className="w-full"
          />
        </div>
        <div className="bg-yellow-400 pb-3">
          <div className="grid gap-3 grid-cols-3 px-3">
            {recommandedProducts?.data?.data?.product_list
              ?.slice(0, 9)
              ?.map((product, index) => {
                return (
                  <div
                    key={index + 1}
                    className="bg-white dark:bg-zinc-900 p-2 rounded"
                    onClick={() =>
                      navigate(`/product/${product.id}/${product.slug}`)
                    }
                  >
                    <img
                      src={product.variant_image}
                      alt=""
                      className="rounded"
                    />
                    <p className="text-sm w-24 overflow-hidden whitespace-nowrap text-ellipsis font-semibold">
                      {product.title}
                    </p>
                    <p className="text-sm text-green-500">
                      From ₹{product.actual_price}
                    </p>
                  </div>
                );
              })}
          </div>
        </div>
        <div className="">
          <p className="absolute pt-10 font-serif font-bold text-2xl text-center w-full">
            Top Rated Products
          </p>
          <img
            src="https://pub-8de1a28f49c04a568b19557f02b6129b.r2.dev/Assets/PhoneVersion/images/s.jpg"
            alt=""
            className="w-full"
          />
        </div>
        <div className="bg-[#BB9BFE] pb-3">
          <div className="grid gap-3 grid-cols-3 px-3">
            {topRatedProducts?.data?.data?.product_list
              ?.slice(0, 9)
              ?.map((product, index) => {
                return (
                  <div
                    key={index + 1}
                    className="bg-white dark:bg-zinc-900 p-2 rounded"
                    onClick={() =>
                      navigate(`/product/${product.id}/${product.slug}`)
                    }
                  >
                    <img
                      src={product.variant_image}
                      alt=""
                      className="rounded"
                    />
                    <p className="text-sm w-24 overflow-hidden whitespace-nowrap text-ellipsis font-semibold">
                      {product.title}
                    </p>
                    <p className="text-sm text-green-500">
                      From ₹{product.actual_price}
                    </p>
                  </div>
                );
              })}
          </div>
        </div>
        <div className="">
          <p className="absolute pt-10 font-serif font-bold text-2xl text-center w-full">
            Most Viewed Products
          </p>
          <img
            src="https://pub-8de1a28f49c04a568b19557f02b6129b.r2.dev/Assets/PhoneVersion/images/k.jpg"
            alt=""
            className="w-full"
          />
        </div>
        <div className="bg-yellow-400 pb-3">
          <div className="grid gap-3 grid-cols-3 px-3">
            {mostViewedProducts?.data?.data?.product_list
              ?.slice(0, 9)
              ?.map((product, index) => {
                return (
                  <div
                    key={index + 1}
                    className=" bg-white dark:bg-zinc-900 p-2 rounded  relative overflow-hidden"
                    onClick={() =>
                      navigate(`/product/${product.id}/${product.slug}`)
                    }
                  >

                    <div className={`absolute top-5 -left-10 w-40  max-w-[9rem] truncate ${product?.stock_sataus === "In-stock" ? "bg-green-500" : "bg-red-500"}  text-white text-center text-xs font-semibold rotate-[-45deg]  shadow-md`}>
                      {product?.stock_sataus}
                    </div>
                    <img
                      src={product.variant_image}
                      alt=""
                      className="rounded"
                    />
                    <p className="text-sm w-24 overflow-hidden whitespace-nowrap text-ellipsis font-semibold">
                      {product.title}
                    </p>
                    <p className="text-sm text-green-500">
                      From ₹{product.actual_price}
                    </p>
                  </div>
                );
              })}
          </div>
        </div>

        {HomePageData?.data?.data && Object?.entries(HomePageData?.data?.data)?.map(([category, items], index) => (
          <>
            {/* Banner with Category Name */}
            <div className="relative w-full">
              <img
                src={
                  index % 2 === 0
                    ? "https://pub-8de1a28f49c04a568b19557f02b6129b.r2.dev/Assets/PhoneVersion/images/k.jpg"
                    : "https://pub-8de1a28f49c04a568b19557f02b6129b.r2.dev/Assets/PhoneVersion/images/s.jpg"
                }
                alt="Category Banner"
                className="w-full h-40 object-cover sm:h-56 md:h-72"
              />
              <p className="absolute inset-0 flex items-center justify-center font-serif font-bold text-xl sm:text-2xl text-white bg-black/30">
                {category}
              </p>
            </div>

            {/* Product Grid */}
            <div className={`${index % 2 === 0 ? "bg-yellow-400" : "bg-[#BB9BFE]"} py-4`}>
              <div className="grid grid-cols-3 sm:grid-cols-3 gap-4 px-3">
                {items?.map((product, idx) => (
                  <div
                    key={idx}
                    className="bg-white dark:bg-zinc-900 rounded-md p-2 shadow hover:shadow-lg cursor-pointer transition relative overflow-hidden"
                    onClick={() => navigate(`/product/${product.id}/${product.slug}`)}
                  >
                    {/* In Stock Ribbon */}
                    <div className={`absolute top-5 -left-10 w-40  max-w-[9rem] truncate ${product?.stock_status === "In-stock" ? "bg-green-500" : "bg-red-500"}  text-white text-center text-xs font-semibold rotate-[-45deg]  shadow-md`}>
                      {product?.stock_status}
                    </div>
                    <img
                      src={product.image}
                      alt={product.title}
                      className="rounded-md w-full h-28 sm:h-32 object-cover mb-2"
                    />
                    <p className="text-sm font-semibold truncate">{product.title}</p>
                    <p className="text-sm text-green-600">From ₹{product.actual_price}</p>
                  </div>
                ))}
              </div>
            </div >
          </>

        ))}
      </div >
    </>
  );
};

export default Home;
